import React, { ReactNode } from 'react';
import cx from 'classnames';

import { Card, Flex, Form, Spin, Title } from 'components/ui';
import { Override } from 'types/common';
import { CardProps, FormProps } from 'types/components';
import { CurrencyCode } from 'types/models';

import styles from './styles.module.css';

import Stripes from './Stripes';

type ChartViewProps<FilterValues> = Override<CardProps, {
  title: ReactNode;
  currency: CurrencyCode;
  filter: ReactNode;
  filterProps: FormProps<FilterValues>;
  loading?: boolean;
}>;

const ChartView = <FilterValues extends object>({
  className,
  title,
  currency,
  filter,
  children,
  filterProps,
  loading,
  ...props
}: ChartViewProps<FilterValues>) => (
  <Card className={cx(styles.root, className)} {...props}>
    <Flex
      className={styles.header}
      gap="small"
      align="center"
      justify="space-between"
      wrap="wrap"
    >
      <Title className={styles.title} level={5}>{title}, {currency}</Title>
      <Form className={styles.filter} {...filterProps}>
        <Flex gap="small" align="center" wrap="wrap">{filter}</Flex>
      </Form>
    </Flex>
    <div className={styles.content}>
      {!loading ? children : <Spin className={styles.spin} />}
    </div>
    <Stripes />
  </Card>
);

export default ChartView;
